
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Star, MapPin, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ImageCarousel from "./ImageCarousel";
import { useProviderMinPrice } from "@/hooks/useProviderMinPrice";
// import { useMemberships } from "@/hooks/useMemberships";

interface WellnessCardProps {
  id: string;
  name: string;
  images?: string[];
  rating: number;
  reviewCount: number;
  location: string;
  services: string[];
  price: string;
  slug?: string;
}

const WellnessCard = ({
  id, name, images = [], rating, reviewCount, location, services, price, slug,
}: WellnessCardProps) => {
  const navigate = useNavigate();
  const { data: minPrice, isLoading: isPriceLoading } = useProviderMinPrice(id);
  // const { data: memberships } = useMemberships(id);

  const handleClick = () => {
    navigate(`/provider/${slug || id}`);
  };

  const displayPrice = () => {
    if (isPriceLoading) {
      return "Loading...";
    }
    
    if (minPrice !== null) {
      return `from £${Number(minPrice).toFixed(2)}`;
    }
    
    return price; // fallback to the original hardcoded price
  };

  // const hasActiveMemberships = memberships && memberships.length > 0;

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow cursor-pointer" onClick={handleClick}>
      <div className="relative h-48">
        <ImageCarousel images={images} alt={name} />
        <div className="absolute bottom-4 left-4 text-white z-10">
          <div className="text-xs opacity-80">Wellness Center</div>
        </div>
      </div>
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-semibold text-lg flex-1">{name}</h3>
          {/* {hasActiveMemberships && (
            <Badge variant="secondary" className="bg-gradient-to-r from-blue-500 to-purple-600 text-white border-0 text-xs ml-2">
              <Check className="h-3 w-3 mr-1" />
              Memberships
            </Badge>
          )} */}
        </div>
        
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center gap-1">
            <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
            <span className="text-sm font-medium">{rating}</span>
          </div>
          <span className="text-sm text-gray-500">({reviewCount} reviews)</span>
        </div>
        
        <div className="flex items-center gap-1 text-sm text-gray-600 mb-3">
          <MapPin className="h-4 w-4" />
          {location}
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex flex-wrap gap-1">
            {services.slice(0, 3).map((service, index) => (
              <span key={index} className="px-2 py-1 bg-gray-100 text-xs rounded-full text-gray-600">
                {service}
              </span>
            ))}
            {services.length > 3 && (
              <span className="px-2 py-1 bg-gray-100 text-xs rounded-full text-gray-600">
                +{services.length - 3} more
              </span>
            )}
          </div>
          
          <div className="text-right ml-4">
            <span className="text-lg font-semibold">{displayPrice()}</span>
            <span className="text-sm text-gray-500">/visit</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WellnessCard;
